import React, { Fragment, useState, useEffect } from "react";

import { connect, useDispatch } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import { goBack } from "connected-react-router";
import { Col, Row } from "react-bootstrap";
import { arrayOf, bool, string } from "prop-types";
import Image from "pages/_components/Image";
import * as i18nUtils from "util/i18n";
import Nav from "pages/_components/Nav";
import I18n from "pages/_components/I18n";
import { actions as actionSoftToken, selectors as selectorSoftToken } from "reducers/softToken";
import SlideDesvincularToken from "./_components/SlideDesvincularToken";

const QueryToken = ({ isMobile, devices, isFetching, deviceStatus }) => {
    const dispatch = useDispatch();
    const [deviceDelete, setdeviceDelete] = useState({ shortLabel: "", idDevice: "" });
    const [slideVisible, setslideVisible] = useState(false);
    const [formRef, setFormRef] = useState();
    const credentialType = "password";

    useEffect(() => {
        dispatch(actionSoftToken.getDevicesByUser());
    }, []);

    useEffect(() => {
        if (deviceStatus && deviceStatus === "INVALID_CREDENTIAL") {
            formRef.setErrors({
                password: i18nUtils.get(
                    credentialType === "password"
                        ? "preferences.password.password.incorrect"
                        : "login.step1.secondFactor.invalid",
                ),
            });
        }
    }, [deviceStatus]);

    const reemplazarDispositivo = (password) => {
        const { shortLabel, idDevice } = deviceDelete;
        dispatch(
            actionSoftToken.deleteUserDevice({
                shortLabel,
                idDevice,
                _password: password,
            }),
        );
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    return (
        <Fragment>
            <Head titleText={isMobile ? "Activación de Token" : "Gestión de Token"} onBack={onHeaderBack} />
            <MainContainer showLoader={isFetching}>
                <div>
                    <Col xs={12} md={8} mdOffset={2}>
                        <h1 className="text-center">
                            <CustomText
                                text={i18nUtils.get("preferences.myToken.devicelink", "Dispositivo vinculado")}
                            />
                        </h1>
                    </Col>
                    <div className="ilustracion text-center">
                        <Image src="figma/illustrations/onboarding3.svg" className="svg-image logo" />
                    </div>
                    <br />
                    <CustomText
                        text={i18nUtils.get(
                            "preferences.myToken.getTokenAuth",
                            "A partir de este momento vas a poder utilizar el token virtual como método de autenticación.",
                        )}
                    />
                    <br />
                    <br />
                    <strong>Dispositivo vinculado</strong>
                    <Col xs={12} md={8} mdOffset={2} className="box box-border-soft" style={{ padding: "20px" }}>
                        {devices.map((item) => (
                            <Row>
                                <Col lg={10} md={10} sm={8}>
                                    <b>
                                        <CustomText text={JSON.parse(item.extraInfo)?.shortLabel ?? ""} />
                                    </b>
                                </Col>
                                <Col
                                    lg={2}
                                    md={2}
                                    sm={4}
                                    onClick={() => {
                                        setslideVisible(true);
                                        setdeviceDelete({
                                            shortLabel: JSON.parse(item.extraInfo)?.shortLabel ?? "",
                                            idDevice: JSON.parse(item.extraInfo)?.idDevice,
                                        });
                                    }}>
                                    <Nav className="btn btn-outline" href="#">
                                        <Image src="images/delete-message.svg" className="svg-icon svg-caret" />
                                        <I18n id="administration.delete" />
                                    </Nav>
                                </Col>
                            </Row>
                        ))}
                    </Col>
                </div>
            </MainContainer>

            <SlideDesvincularToken
                slideIsVisible={slideVisible}
                closeSlide={() => setslideVisible(false)}
                setFormRef={setFormRef}
                deviceDelete={deviceDelete}
                reemplazarDispositivo={reemplazarDispositivo}
            />
        </Fragment>
    );
};

QueryToken.propTypes = {
    isMobile: bool.isRequired,
    devices: arrayOf([]).isRequired,
    isFetching: bool,
    deviceStatus: string,
};

QueryToken.defaultProps = {
    isFetching: false,
    deviceStatus: false,
};

const mapStateToProps = (state) => ({
    devices: selectorSoftToken.getDevicesByUser(state),
    isFetching: selectorSoftToken.getFetching(state),
    deviceStatus: selectorSoftToken.getDeviceStatus(state),
});

export default connect(mapStateToProps)(QueryToken);
